var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-frip-primary text-sm"},_vm._l((_vm.pathList),function(path){return _c('div',{key:path.path},[_vm._v(" "+_vm._s(path.representative ? '[대표 카테고리] : ' + path.path : path.path)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }